import { useEffect, useState } from "react";
import moment from "moment";
import { useLocation } from "react-router-dom";
import * as comprobanteService from "../services/comprobante.service";
import Main from "./Main";
const MainContainer = () => {
  const location = useLocation();
  if (location.state) {
    location.state.menuDefault = 1;
    window.localStorage.setItem("user", JSON.stringify(location.state));
    delete location.state;
  }
  let user = null;
  user = JSON.parse(window.localStorage.getItem("user"));
  const [state, setState] = useState({
    form: {},
    lista: {},
    loading: false,
    showDetail: false,
    showItem: false,
    error: null,
    modalDetail: {},
    modalItem: {},
  });
  useEffect(() => {
    if (user) {
      let defaultEmpresa =
        user && user.empresas
          ? user.empresas.filter((item) => item.esDefault === true)
          : null;
      user.sucursales = defaultEmpresa ? defaultEmpresa[0].sucursales : [];
      user.defaultSucursal = user.sucursales
        ? user.sucursales.filter((item) => item.esDefault === true)
        : null;
      user.defaultSucursal = user.defaultSucursal
        ? user.defaultSucursal[0].Sucursal
        : null;
      user.defaultEmpresa = defaultEmpresa[0].abreviacion;
      const daysInterval = 30;
      const startDate = new Date().setDate(new Date().getDate() - daysInterval);
      setState({
        form: {
          startDate: new Date(startDate),
          endDate: new Date(),
          defaultEmpresa: user.defaultEmpresa,
          sucursales: user.sucursales,
          defaultSucursal: user.defaultSucursal,
          docIdentidad: user.docIdentidad,
        },
        lista: {
          data: null,
          columns: null,
          process: true,
        },
        loading: false,
        showDetail: false,
        showItem: false,
        error: null,
        modalDetail: {},
        modalItem: {},
      });
    }
  }, []);

  const getFormat_MMDDYYYY = (date_iso_format) => {
    return moment(date_iso_format).format("MM/DD/YYYY");
  };
  const handleSearch = async (e) => {
    try {
      e.preventDefault();
      let {
        startDate,
        endDate,
        defaultEmpresa,
        defaultSucursal,
        docIdentidad,
      } = state.form;
      let params = {
        startDate: getFormat_MMDDYYYY(startDate),
        endDate: getFormat_MMDDYYYY(endDate),
        defaultEmpresa: defaultEmpresa,
        docIdentidad: docIdentidad,
      };
      if (defaultSucursal) {
        params.sucursal = defaultSucursal;
      }
      const res = await comprobanteService.getGuias(params);
      res.columns = [];
      if (res.data.length > 0) {
        Object.getOwnPropertyNames(res.data[0]).forEach((val, idx, array) => {
          res.columns.push({
            name: val,
          });
        });
      }
      const dataTempLista = res.data.map((item) => {
        return {
          ...item,
          toggleSelected: false,
        };
      });
      setState({
        form: {
          ...state.form,
        },
        lista: {
          data: dataTempLista,
          columns: res.columns,
          process: false,
          clickHandler: handleOpenDetail,
        },
        showDetail: false,
        showItem: false,
        modalDetail: {},
        modalItem: {},
      });
    } catch (error) {
      console.log(error);
    }
  };
  const handleChange = (e, nameProp) => {
    switch (nameProp) {
      case "defaultEmpresa":
        for (let index = 0; index < user.empresas.length; index++) {
          const element = user.empresas[index];
          element.esDefault = false;
          if (element.abreviacion === e.target.value) {
            element.esDefault = true;
          }
        }
        let defaultEmpresa = user.empresas.filter(
          (item) => item.esDefault === true
        );
        user.sucursales = defaultEmpresa[0].sucursales;
        user.defaultSucursal = user.sucursales
          ? user.sucursales.filter((item) => item.esDefault === true)
          : null;
        user.defaultSucursal = user.defaultSucursal
          ? user.defaultSucursal[0].Sucursal
          : null;
        user.defaultEmpresa = defaultEmpresa[0].abreviacion;
        setState({
          form: {
            ...state.form,
            sucursales: user.sucursales,
            defaultSucursal: user.defaultSucursal,
            [nameProp]: e.target.value,
          },
          lista: {},
          showDetail: false,
          showItem: false,
        });
        break;
      case "defaultSucursal":
        if (state.form.sucursales && state.form.sucursales.length > 0) {
          for (let index = 0; index < state.form.sucursales.length; index++) {
            const element = state.form.sucursales[index];
            element.esDefault = false;
            if (element.Sucursal === e.target.value) {
              element.esDefault = true;
            }
          }
        }
        setState({
          form: {
            ...state.form,
            [nameProp]: e.target.value,
          },
          lista: {},
          showDetail: false,
          showItem: false,
        });
        break;
      default:
        setState({
          form: {
            ...state.form,
            [nameProp]: e,
          },
          lista: {},
          showDetail: false,
          showItem: false,
        });
        break;
    }
  };
  const handleOpenDetail = async (row, e) => {
    try {
      e.preventDefault();
      const dataTempLista = state.lista.data.map((item) => {
        return {
          ...item,
          toggleSelected: item.GuiaID === row.GuiaID,
        };
      });
      let params = { ...row };
      params.defaultEmpresa = state.form.defaultEmpresa;
      params.tieneSucursal =
        state.form.sucursales && state.form.sucursales.length > 0;
      const res = await comprobanteService.getGuiaDetalle(params);
      //Obteniendo detalle de la guia
      let resultGuiaDetalle = {};
      resultGuiaDetalle.data = res.data.resultGuiaDetalle;
      const dataTempItem = resultGuiaDetalle.data.map((item) => {
        return {
          ...item,
          toggleSelected: false,
        };
      });
      resultGuiaDetalle.columns = [];
      if (resultGuiaDetalle.data.length > 0) {
        Object.getOwnPropertyNames(resultGuiaDetalle.data[0]).forEach(
          (val, idx, array) => {
            resultGuiaDetalle.columns.push({
              name: val,
            });
          }
        );
      }
      //Obteniendo detalle de los docuemntos para despacho
      let requerimientoDespachoCodigo = "";
      // let requerimientoDespachoCodigoTraduccion = "";
      let resultGuiaClienteDespacho = {};
      resultGuiaClienteDespacho.data = res.data.resultGuiaClienteDespacho[0];
      let listadoRequerimientosTexto = [];
      let listadoRequerimientosCodigo = [];
      let listadoRequerimientosTraduccion = [];
      Object.getOwnPropertyNames(resultGuiaClienteDespacho.data).forEach(
        function (val, idx, array) {
          if (val.indexOf("|") !== -1) {
            let datoCodigo = val.split("|")[0];
            let datoTexto = val.split("|")[1];
            if (resultGuiaClienteDespacho.data[val] === true) {
              listadoRequerimientosTexto.push(datoTexto);
              if (!listadoRequerimientosCodigo.includes(datoCodigo)) {
                listadoRequerimientosCodigo.push(datoCodigo);
              }

              if (val.indexOf("Traducción") !== -1) {
                listadoRequerimientosTraduccion.push(datoCodigo);
              }
            }
          }
        }
      );
      requerimientoDespachoCodigo = listadoRequerimientosCodigo
        .toString()
        .replace(/,/g, "','"); //Navegoadores antiguos
      // requerimientoDespachoCodigoTraduccion =
      //   listadoRequerimientosTraduccion.toString();
      // let requerimientoDespacho = listadoRequerimientosTexto.toString();
      // let requerimientoDespachoOtros =
      //   "Copias: " +
      //   resultGuiaClienteDespacho.data.Copias +
      //   (resultGuiaClienteDespacho.data
      //     ? " , Observacion: " + resultGuiaClienteDespacho.data.Observacion
      //     : "");
      setState({
        form: {
          ...state.form,
        },
        lista: {
          ...state.lista,
          data: dataTempLista,
        },
        // lista: {
        //   ...state.lista,
        // },
        showDetail: true,
        showItem: false,
        modalDetail: {
          title: `Detalle de guia ${row.Guia}`,
          filtro: requerimientoDespachoCodigo,
          filtroTraduccion: listadoRequerimientosTraduccion,
          lista: {
            data: dataTempItem,
            columns: resultGuiaDetalle.columns,
          },
        },
        modalItem: {},
      });
      row.toggleSelected = true;
    } catch (error) {
      console.log(error);
    }
  };
  const handleOpenItem = async (row) => {
    let params = {
      IDProducto: row.IDProducto,
      IDLote: row.IDLote,
      Numero: row.RS,
      Filtro: state.modalDetail.filtro,
    };
    params.defaultEmpresa = state.form.defaultEmpresa;
    const res = await comprobanteService.getItem(params);
    let dataResultadoDetalleDigital = res.data;
    let cabeceraDigital = [];
    for (let index = 0; index < dataResultadoDetalleDigital.length; index++) {
      const element = dataResultadoDetalleDigital[index];
      //Añadimos la primera cabecera
      if (!index) {
        cabeceraDigital.push({
          Codigo: element.TipoCodigo,
          Descripcion: element.TipoDescripcion,
        });
        continue;
      }
      //Almacenamos en un array los codigo existentes de cabecera
      let cabeceraSoloCodigos = [];
      for (let x = 0; x < cabeceraDigital.length; x++) {
        const cabecera = cabeceraDigital[x];
        cabeceraSoloCodigos.push(cabecera.Codigo);
      }
      if (!cabeceraSoloCodigos.includes(element.TipoCodigo)) {
        cabeceraDigital.push({
          Codigo: element.TipoCodigo,
          Descripcion: element.TipoDescripcion,
        });
      }
    }
    const dataTempItem = state.modalDetail.lista.data.map((item) => {
      return {
        ...item,
        toggleSelected:
          item.IDProducto + "" + item.IDLote ===
          row.IDProducto + "" + row.IDLote,
      };
    });
    setState({
      form: {
        ...state.form,
      },
      lista: {
        ...state.lista,
      },
      showDetail: false,
      showItem: true,
      modalDetail: {
        ...state.modalDetail,
        lista: {
          ...state.modalDetail.lista,
          data: dataTempItem,
        },
      },
      modalItem: {
        title: `Detalle de Item`,
        items: dataResultadoDetalleDigital,
        itemSelect: row,
        cabecera: cabeceraDigital,
      },
    });
  };
  const handleCloseDetail = (e) => {
    setState({
      form: {
        ...state.form,
      },
      lista: {
        ...state.lista,
      },
      showDetail: false,
      showItem: false,
      modalDetail: {},
      modalItem: {},
    });
  };
  const handleCloseItem = (e) => {
    setState({
      form: {
        ...state.form,
      },
      lista: {
        ...state.lista,
      },
      showDetail: true,
      showItem: false,
      modalDetail: { ...state.modalDetail },
      modalItem: {},
    });
  };
  return (
    <Main
      data={state}
      user={user}
      handleSearch={handleSearch}
      handleChange={handleChange}
      handleOpenDetail={handleOpenDetail}
      handleOpenItem={handleOpenItem}
      handleCloseDetail={handleCloseDetail}
      handleCloseItem={handleCloseItem}
    />
  );
};
export default MainContainer;
